module.exports = "<a ui-sref=\".pagos.pendientes()\">\r\n  <app-launcher color=\"#00BFFF\">\r\n    <icon>Pg</icon>\r\n    <label>Pagos</label>\r\n  </app-launcher>\r\n</a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/viaticos/components/pagos/launcher/template.html
// module id = 3258
// module chunks = 0